<template>
  <div class="main">
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 80%"
    >
      DELIVERY INSTRUCTIONS
    </div>

    <div>
      <!-- Door direction-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>1</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[0] && $v.doorDirection.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="doordirection box">
              <h4>
                Preferred Door Direction At Delivery
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="showDoorDirection = true"
                >
                  <v-icon color="#6dbe45">info</v-icon>
                </span>

                <v-dialog v-model="showDoorDirection" max-width="500px">
                  <div class="dialog">
                    <v-icon
                      @click="showDoorDirection = false"
                      style="border-radius: 0.8em; background: #6dbe45"
                      >close</v-icon
                    >
                    <h5>{{ doormessage }}</h5>
                  </div>
                </v-dialog>

                <small
                  v-if="!$v.doorDirection.required"
                  style="color: red; font-size: 18px; font-weight: 800"
                  >*</small
                >
              </h4>

              <label class="grow">
                <input
                  type="radio"
                  id="Doors Toward Cab (off last)"
                  value="Doors Toward Cab (off last)"
                  v-model="bind_doorDirection"
                  @change="handleUserInputUpdate(0)"
                />
                <img
                  src="https://images-generic.s3-us-west-2.amazonaws.com/PreDelivery-Door-Direction-Towards-Cab-Off-Last.png"
                  width="80%"
                />
                <figcaption style="font-size: 16px">
                  Doors Toward Cab (off last)
                </figcaption>
              </label>
              <label class="grow">
                <input
                  type="radio"
                  id="Doors Toward Rear (off first)"
                  value="Doors Toward Rear (off first)"
                  v-model="bind_doorDirection"
                  @change="handleUserInputUpdate(0)"
                />
                <img
                  src="https://images-generic.s3-us-west-2.amazonaws.com/PreDelivery-Door-Direction-Towards-Rear-Off-First.png"
                  width="80%"
                />
                <figcaption style="font-size: 16px">
                  Doors Toward Rear (off first)
                </figcaption>
              </label>
            </div>
          </v-card>
          <!-- Door direction ends-->
        </v-col>
        <v-col cols="12" sm="9">
          <!-- Space question -->
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>2</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[1] && $v.deliverySpace.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="space box">
              <h4>
                Please Confirm You Have Enough Space For Delivery
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="showSpace = true"
                >
                  <v-icon color="#6dbe45">info</v-icon>
                </span>

                <v-dialog v-model="showSpace" max-width="500px">
                  <div class="dialog">
                    <v-icon
                      @click="showSpace = false"
                      style="border-radius: 0.8em; background: #6dbe45"
                      >close</v-icon
                    >
                    <h5>
                      {{ spacemessage }}
                      <span>
                        <a
                          href="https://westerncontainersales.com/buy-shipping-containers-online/delivery/"
                          target="_blank"
                          style="color: #6dbe45"
                          >Container Ground Level Delivery</a
                        >
                      </span>
                    </h5>
                  </div>
                </v-dialog>
                <strong
                  v-if="!$v.deliverySpace.required"
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <img
                src="https://images-wcs.s3-us-west-2.amazonaws.com/Delivery_Space_20210402.png"
                style="padding: 10px"
              />
              <br />
              <br />
              <label for="space_present">
                <input
                  type="radio"
                  id="space_present"
                  value="I confirm there is enough space"
                  v-model="bind_deliverySpace"
                  @change="handleUserInputUpdate(1)"
                />
                I Have Enough Space to Safely Deliver
              </label>
            </div>
          </v-card>
          <!-- Space question ends -->
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <!-- Rust question -->
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>3</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[2] && $v.deliveryRustAcknowledge.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="rust box">
              <h4>
                Please Confirm You Understand All Used Shipping Containers Will
                Have Rust & Dents
                <strong
                  v-if="!$v.deliveryRustAcknowledge.required"
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <h6>
                {{ rustmessage_1 }}
                <span>
                  <a
                    href="https://westerncontainersales.com/buy-shipping-containers-online/guarantee/"
                    target="_blank"
                    style="color: #6dbe45"
                  >
                    every container we sell is covered by our 1-year warranty.
                  </a>
                </span>
                {{ rustmessage_2 }}
                <span>
                  <a
                    href="https://westerncontainersales.com/sample-pics/"
                    target="_blank"
                    style="color: #6dbe45"
                    >Shipping Container Sample Photos by Condition.</a
                  >
                </span>
              </h6>
              <h6>{{ rustmessage_3 }}</h6>
              <label for="rust_accept">
                <input
                  type="radio"
                  id="rust_accept"
                  value="Accepted"
                  v-model="bind_rustAcknowledgement"
                  @change="handleUserInputUpdate(2)"
                />
                I Understand that All Used Shipping Containers Have Rust & Dents
              </label>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Rust question ends -->
      <!-- Surface Question Starts-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>4</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[3] && $v.deliverySurface.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="surface box">
              <h4>
                What Type of Surface Will We Be Delivering On?
                <small
                  v-if="!$v.deliverySurface.required"
                  style="color: red; font-size: 18px; font-weight: 800"
                  >*</small
                >
              </h4>
              <div class="iframe-container">
                <iframe
                  width="600"
                  height="315"
                  src="https://www.youtube-nocookie.com/embed/JskBUe1jpZ4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
                <div style="text-align: left; margin-top: 20px">
                  <label for="hard_surface">
                    <input
                      type="radio"
                      id="hard_surface"
                      value="Hard surface"
                      v-model="bind_deliverySurfaceType"
                      @change="handleUserInputUpdate(3)"
                    />
                    Hard surfaces only (asphalt, concrete, gravel, etc.)
                  </label>
                  <br />
                  <label for="soft_surface">
                    <input
                      type="radio"
                      id="soft_surface"
                      value="Soft surface"
                      v-model="bind_deliverySurfaceType"
                      @change="softSurfaceConfirmation(3)"
                    />
                    The truck will drive on a soft surface during delivery
                    (grass, dirt, etc.)
                  </label>
                </div>
              </div>
              <!-- soft surface confirmtaion start-->
              <v-dialog
                v-model="softSurfaceInfoDialog"
                persistent
                max-width="500"
              >
                <v-card style="padding: 10px">
                  <div class="text-left">
                    <strong>
                      I understand that I must also provide a secondary delivery
                      location with a hard surface in case the driver is unable
                      to deliver to the preferred location on a soft surface. I
                      am responsible to notify {{ domainName }}
                      at least one (1) full business day prior to delivery if
                      the delivery date needs to be changed for any reason.
                    </strong>
                    <span style="font-weight: 100">{{
                      softsurfacemessage
                    }}</span>
                  </div>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-group">
                      <label for="soft_surface_acknowledgement">
                        <input
                          type="checkbox"
                          id="soft_surface_acknowledgement"
                          style="cursor: pointer"
                          @click="softSurfaceInfoDialog = false"
                          @change="handleUserInputUpdate(3)"
                          v-model="bind_softSurfaceAcknowledge"
                        />
                        Accept
                      </label>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- soft surface confirmtaion ends-->
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Surface Question Ends-->
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "DeliveryInstructions",
  data() {
    return {
      showDoorDirection: false,
      doormessage:
        "It's not easy to turn a container around, so please let us know ahead of time which direction you'd like the doors to face when they roll off the truck at delivery. The customer will be charged at $125/hr for all time associated with turning the container around at the delivery location, if required.",
      showSpace: false,
      spacemessage:
        "By clicking the box below, customer verifies that they have enough space on site to safely deliver. Customer acknowledges that if driver is not able to safely deliver that they may still be charged for delivery as a " +
        "dry run" +
        "fee. Customer acknowledges they have reviewed the delivery information on our website:",
      rustmessage_1:
        "By clicking the box below, customer verifies that they understand all used shipping containers will have rust and dents. Containers are all guaranteed to be structurally sound, and",
      rustmessage_2:
        "For more information on what to expect, please checkout the sample photos on our website:",
      rustmessage_3:
        "(NOTE: customers who purchased a One Trip container should still click the box, as One Trip containers do have a few dents, usually)",
      softSurfaceInfoDialog: false,
      softsurfacemessage:
        " Soft surfaces such as grass or dirt increases the likelihood of a dry run, usually due to the site being too wet for the truck to avoid getting stuck. Please make sure to contact us at least a day ahead of your delivery date if you need to push back delivery due to site conditions in order to avoid a dry run fee.",
      domainName: "",
      overlay: [false, false, false, false],
    };
  },
  computed: {
    ...mapGetters({
      doorDirection: types.DELIVERY_DOORDIRECTION,
      deliverySpace: types.DELIVERY_SPACE,
      deliverySurface: types.DELIVERY_SURFACETYPE,
      softSurfaceAcknowledgement: types.DELIVERY_SOFTSURFACEACKNOWLEDGE,
      deliveryRustAcknowledge: types.DELIVERY_RUSTACKNOWLEDGE,
      predelivery: types.PREDELIVERYANSWERS,
      COUNTRY_CODE: types.COUNTRYCODE,
    }),
    bind_deliverySurfaceType: {
      get() {
        return this.deliverySurface;
      },
      set(value) {
        this.updateDeliverySurface(value);
      },
    },
    bind_softSurfaceAcknowledge: {
      get() {
        return this.softSurfaceAcknowledgement;
      },
      set(value) {
        this.updateSoftSurfaceAcknowledgement(value);
      },
    },
    bind_doorDirection: {
      get() {
        return this.doorDirection;
      },
      set(value) {
        this.updateDoorDirection(value);
      },
    },
    bind_rustAcknowledgement: {
      get() {
        return this.deliveryRustAcknowledge;
      },
      set(value) {
        this.updateRustAcknowledge(value);
      },
    },
    bind_deliverySpace: {
      get() {
        return this.deliverySpace;
      },
      set(value) {
        this.updateDeliverySpace(value);
      },
    },
  },
  validations: {
    doorDirection: {
      required,
    },
    deliverySpace: {
      required,
    },
    deliveryRustAcknowledge: {
      required,
    },
    deliverySurface: {
      required,
    },
    softSurfaceAcknowledgement: {
      required,
    },
  },
  mounted() {
    //get domain name based on country code.
    this.domainName =
      this.COUNTRY_CODE === "CA"
        ? "Northern Container Sales"
        : "Western Container Sales";
  },
  methods: {
    ...mapActions({
      updateDoorDirection: types.ACTIONS_UPDATE_DELIVERY_DOORDIRECTION,
      updateDeliverySpace: types.ACTIONS_UPDATE_DELIVERY_SPACE,
      updateDeliverySurface: types.ACTIONS_UPDATE_DELIVERY_SURFACETYPE,
      updateSoftSurfaceAcknowledgement:
        types.ACTIONS_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE,
      updateRustAcknowledge: types.ACTIONS_UPDATE_DELIVERY_RUSTACKNOWLEDGE,
    }),
    handleUserInputUpdate(idx) {
      //Check animation will appear for 1 second
      this.$set(this.overlay, idx, true);
      setTimeout(() => {
        this.$set(this.overlay, idx, false);
      }, 800);
      this.maintainSessionStorage();
    },
    maintainSessionStorage() {
      const predelivery = JSON.stringify(this.predelivery);
      sessionStorage.setItem("predelivery", predelivery);
    },
    softSurfaceConfirmation(idx) {
      //Open confirmtaion dialog only if user has not accepted the condition.
      if (!this.softSurfaceAcknowledgement) {
        this.softSurfaceInfoDialog = true;
        return;
      }
      this.handleUserInputUpdate(idx);
    },
  },
};
</script>

<style scoped>
.question_cards {
  padding-top: 30px;
  padding-bottom: 20px;
  margin: 20px;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
}

h5 {
  font-size: 14px;
  font-weight: normal;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

h6 {
  font-style: italic;
  font-size: 15px;
  margin-bottom: 20px;
}

.doordirection input[type="radio"] {
  display: none;
}

.doordirection input[type="radio"]:checked + img {
  border: 5px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

label {
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}

input[type="radio"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.box {
  color: #00587d;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

.iframe-container {
  width: 600px;
  margin: auto;
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

@media only screen and (max-width: 800px) {
  .iframe-container {
    position: relative;
    width: 100%;
    height: 90%;
  }
  .iframe-container iframe {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 90%;
  }
}

.updateAnimation {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>